<div [ngStyle]="{ height: '100%' }" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <div [ngSwitch]="viewMode">
      <div *ngSwitchCase="'upload'" [@fadeInEnter]>
        <ol class="u-padding-0-16">
          <li class="u-marginBottom-16">
            <p class="u-marginBottom-8">
              {{ customText.downloadInstruction }}
            </p>
            <app-download-csv-template
              [data]="templateData"
              [isButton]="true"
              color="accent"
              [text]="customText.downloadTemplateCta"
              [title]="templateTitle"
              [type]="templateType"
            >
            </app-download-csv-template>
          </li>
          <li class="u-marginBottom-16">
            <p class="u-marginBottom-8">
              {{ customText.uploadInstruction }}
            </p>
            <app-upload-csv-button
              buttonText="Browse for file & upload"
              [disabled]="isLoading"
              (afterAddingFile)="onAfterAddingFile($event)"
              i18n-buttonText="@@uploadCsvListDialog.uploadCta"
            >
            </app-upload-csv-button>
          </li>
        </ol>
        <div
          *ngIf="customText.warningText"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          class="color-grey-300"
        >
          <mat-icon class="md-16">info_outline</mat-icon>
          <p class="text-caption">{{ customText.warningText }}</p>
        </div>
      </div>
      <div *ngSwitchDefault [@fadeInEnter]>
        <p class="u-marginBottom-16">{{ description }}</p>
        <div *ngIf="items?.length" class="u-border-grey100" [@fadeInEnter]>
          <div *ngIf="1 === csvHeaders.length">
            <div *ngFor="let item of items; let index = index">
              <div
                *ngFor="let header of csvMappedHeaders"
                class="u-padding-8 u-textTruncate"
                [ngClass]="{ 'bg-color-grey-50': 1 === index % 2 }"
              >
                <span> {{ item.value[header] }} </span>
              </div>
              <p
                *ngIf="item.error"
                [@fadeInEnter]
                class="color-orange text-caption u-padding-8"
              >
                {{ item.error }}
              </p>
            </div>
          </div>
          <div *ngIf="1 < csvHeaders.length">
            <table mat-table [dataSource]="dataSource" class="u-width-100">
              <ng-container matColumnDef="item">
                <td mat-cell *matCellDef="let row" [ngStyle]="{ padding: 0 }">
                  <div
                    *ngFor="let header of csvHeaders; let index = index"
                    [ngClass]="{ 'bg-color-grey-50': 1 === index % 2 }"
                    fxLayout="row"
                  >
                    <div fxFlex="1 1 50%" class="u-padding-8 color-grey-300">
                      {{ header }}
                    </div>
                    <div fxFlex="1 1 50%" class="u-padding-8">
                      {{ row.value[csvMappedHeaders[index]] }}
                    </div>
                  </div>
                  <div
                    *ngIf="row.error"
                    [@fadeInEnter]
                    class="color-orange text-caption u-padding-8"
                  >
                    {{ row.error }}
                  </div>
                </td>
              </ng-container>
              <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
            </table>

            <mat-paginator
              [length]="totalCount"
              [pageIndex]="currentPage"
              [pageSize]="pageSize"
              (page)="onPageChange($event)"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="'upload' !== viewMode"
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
    [ngSwitch]="viewMode"
  >
    <div *ngSwitchCase="'review'" [@fadeInEnter] fxLayout="row">
      <button
        mat-button
        [disabled]="isLoading"
        (click)="viewMode = 'upload'"
        i18n="@@global.back"
      >
        Back
      </button>
      <div *ngIf="items?.length" class="u-marginRight-8">
        <button
          mat-raised-button
          color="primary"
          [disabled]="isLoading"
          (click)="ctaClicked(items)"
        >
          {{ cta }}
          <i
            *ngIf="isLoading"
            nz-icon
            nzType="sync"
            nzTheme="outline"
            nzSpin
            class="u-marginLeft-8"
          ></i>
        </button>
      </div>
    </div>
    <div *ngSwitchCase="'results'" [@fadeInEnter]>
      <button
        mat-raised-button
        (click)="closeDrawer()"
        color="primary"
        i18n="@@global.done"
      >
        Done
      </button>
    </div>
  </div>
</div>
